<template>
  <div class="system-user-review-add">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请系统用户复核</h4>
        </Row>
        <Form inline :label-width="70" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" style="width: 100%" prop="remark">
                <vue-editor v-model="baseInfo.remark" ref="myQuillEditorBody" :editorOptions="editorOptionBody" class="system-user-review-add-content"></vue-editor>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="PMO" style="width: 100%" prop="pmo_user">
                <Select v-model="baseInfo.pmo_user" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in all_user_list" :key="item.key" :value="item.key">{{ item.label }}</Option>
            </Select>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="24">
              <FormItem label="附件" style="width: 100%">
                 <Upload  :action="workFlowBaseUploadUrl"
                          :headers="uploadHeader"
                          :on-success="uploadEnclosureSuccess"
                          :on-error="uploadEnclosureError"
                          :on-format-error="uploadEnclosureFormatError"
                          :on-exceeded-size="uploadEnclosureExceededSize"
                          :show-upload-list="true"
                          :max-size="10240">
                      <Button icon="ios-cloud-upload-outline" size="small">点击上传</Button>
                    </Upload>
              </FormItem>
            </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createSystemUserReview, workFlowBaseUploadUrl } from '@/api/workflow/system_user_review'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'systemUserReviewAdd',
  components: {
    VueEditor
  },
  data () {
    return {
      pm_visible: false,
      all_user_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      workFlowBaseUploadUrl: workFlowBaseUploadUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        title: '',
        ops_user: this.$store.state.user.userId,
        remark: '',
        ops_file: []
      },
      version: {},
      baseInfoFormRules: {
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        remark: { required: true, message: '流程内容不能为空', trigger: 'blur' },
        pmo_user: { required: true, message: 'PMO不能为空', type: 'number', trigger: 'change' }
      },
      submitting: false
    }
  },
  mounted: function () {
    this.getAllUsersData()
  },
  // watch: {
  //   '$store.state.user.defaultTenant' () {
  //     // this.getModuleList()
  //   }
  // },
  methods: {
    onSelectPm (value) {
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': 'PMO组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },

    // 上传附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        this.baseInfo.ops_file.push(res)
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为50M'
      })
    },

    // 提交
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.submitting = true
          createSystemUserReview(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'systemUserReviewDetail', params: { id: res.data.id }, query: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }

}
</script>

<style lang="less">
  @import '../../base.less';
  .system-user-review-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
